import Payment, { PayTypes } from '@/models/payment'

import CreditInfo from './CreditInfoService'
import RefundInfo from './RefundInfoService'
import RegularPaymentInfoService from './RegularPaymentInfoService'
import TransferInfo from './TransferInfoService'

export default class MasterPaymentInfoService {
  payment: Payment

  constructor(payment: Payment) {
    this.payment = payment
  }

  call(): string {
    if (this.payment.isRefund) {
      return new RefundInfo(this.payment).call()
    } else if (this.payment.isTransfer) {
      return new TransferInfo(this.payment).call()
    } else if (this.payment.payType === PayTypes.Credit) {
      return new CreditInfo(this.payment).call()
    } else {
      return new RegularPaymentInfoService(this.payment).call()
    }
  }
}
